import memoize from 'transmute/memoize';
import { SUBSCRIPTIONS_RECORD_PAYMENT_GATE, NON_BILLABLE_GATE } from 'invoices-ui-lib/constants/gates';
export const getIsUngatedForRecordPaymentsAutoCollect = memoize(gates => gates.includes(SUBSCRIPTIONS_RECORD_PAYMENT_GATE));
export const getIsUngatedForNonBillable = gates => gates.includes(NON_BILLABLE_GATE);